import { call, put, takeLatest } from 'redux-saga/effects';
import { ChargebacksActionType, ChargebacksActions } from './actions';
import { GetChargebacksData, Services } from '@card/commonlib';
import { getQueryString } from '../../utils/apiUtils';

function* fetchChargebacks(action: ReturnType<typeof ChargebacksActions.fetchStarted>) {
  const paramsQueryString = getQueryString(action.payload.pagination, action.payload.filters);
  try {
    const chargebacksResponse: GetChargebacksData = yield call(
      Services.getChargebacks,
      paramsQueryString
    );
    yield put(
      ChargebacksActions.fetchSuccess({
        chargebacks: chargebacksResponse.chargebacks,
        settings: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          current_page: action.payload.pagination.page,
          // eslint-disable-next-line @typescript-eslint/camelcase
          total_pages: chargebacksResponse.pages,
          // eslint-disable-next-line @typescript-eslint/camelcase
          total_elements: chargebacksResponse.total_chargebacks,
          total: chargebacksResponse.total
        }
      })
    );
  } catch (error) {
    yield put(ChargebacksActions.fetchError(error));
  }
}

function* generateReport(action: ReturnType<typeof ChargebacksActions.generateReportStarted>) {
  const paramsQueryString = getQueryString(action.payload.pagination, action.payload.filters);
  try {
    yield call(Services.generateChargebacksReport, paramsQueryString);
    yield put(ChargebacksActions.generateReportSuccess());
  } catch (error) {
    yield put(ChargebacksActions.generateReportError(error));
  }
}

function* updateChargeback(action: ReturnType<typeof ChargebacksActions.updateDataStarted>) {
  try {
    yield call(Services.updateChargebackData, action.payload);
    yield put(ChargebacksActions.updateDataSuccess());
  } catch (error) {
    yield put(ChargebacksActions.updateDataError(error));
  }
}

export function* chargebacksSagas() {
  yield takeLatest(ChargebacksActionType.FetchStarted, fetchChargebacks);
  yield takeLatest(ChargebacksActionType.UpdateDataStarted, updateChargeback);
  yield takeLatest(ChargebacksActionType.GenerateReportStarted, generateReport);
}
